<template>
    <div v-if="value" class="dialog fr-ac-jc" :style="{ zIndex: zIndex }">
        <div :class="[`w-${width}`, 'px-30', 'py-30']" style="background: #fff;" @click.stop>
            <slot name="dialogHeader" class="w-100"></slot>
            <slot name="dialogMain" class="w-100"></slot>
            <slot name="dialogFoot" class="w-100"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "DialogView",
    props: {
        width: {
            type: Number,
            default: 50,
        },
        zIndex: {
            type: String,
            default: "20000",
        },
        value: {  // Vue 2 v-model 默认 prop
            type: Boolean,
            default: false,
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.dialog {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    .buttonItem {
        padding: 10px 40px;
        box-sizing: border-box;
        background: #1676ff;
        border-radius: 5px;
        color: #fff;
        text-align: center;
    }
}
</style>
